import { useRef } from "react";
import { AnimatedBeamDemo } from "./components/Beam";
import HeroSection from "./components/HeroSection";
import CardComponent from "./components/CardComponent";
import { BentoGridSection } from "./components/BentoSection";
import { TimelineSection } from "./components/TimeLine";
import { StickyScrollReveal } from "./components/Reveal";
import { BackgroundBoxesDemo } from "./components/CallToAction";
function App() {
  const beamDemoRef = useRef<HTMLDivElement | null>(null);
  const bentoGridRef = useRef<HTMLDivElement | null>(null);

  const scrollToBeamDemo = () => {
    if (beamDemoRef.current) {
      beamDemoRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToBentoGrid = () => {
    if (bentoGridRef.current) {
      bentoGridRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="">
      <HeroSection />
      <CardComponent
        onBeamCardClick={scrollToBeamDemo}
        onBentoCardClick={scrollToBentoGrid}
      />
      <div ref={beamDemoRef}>
        <AnimatedBeamDemo />
      </div>
      <StickyScrollReveal />
      <div ref={bentoGridRef}>
        <BentoGridSection />
      </div>
      <TimelineSection />

      <BackgroundBoxesDemo />

      <footer className="bg-white flex justify-between items-center p-4">
        {/* Left section with larger image on top and two smaller images below */}
        <div className="flex flex-col">
          <div className="flex space-x-2">
            <img
              height={40}
              width={80}
              src="/QuoData_Basis.png"
              alt="Small Placeholder 1"
              className="object-contain pr-2 md:pr-0"
            />
            <img
              height={150}
              width={130}
              src="/QD_Labs_Final_Logo.png"
              alt="Small Placeholder 2"
              className="object-contain pr-8 md:pr-0"
            />
          </div>
        </div>

        {/* Right section with a single large image */}
        <div>
          <img
            width={200}
            height={100}
            src="/augenblick_logo.png"
            alt="Large Placeholder Right"
          />
        </div>
      </footer>
    </div>
  );
}

export default App;
